import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZoomIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconZoomIn"><Path d="M11 8V14" stroke="currentColor" strokeLinecap="square"/><Path d="M14 11L8 11" stroke="currentColor" strokeLinecap="square"/><Path d="M11 18.5C15.1421 18.5 18.5 15.1421 18.5 11C18.5 6.85786 15.1421 3.5 11 3.5C6.85786 3.5 3.5 6.85786 3.5 11C3.5 15.1421 6.85786 18.5 11 18.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M20.25 20.25L16.3 16.3" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconZoomIn;
